











import Vue from "vue";

import iwInputCalendar from "@/encoding/components/buildingBlocks/InputCalendar.vue";
import { datetime } from "datetime-attribute";

export default Vue.extend({
    components: {
        iwInputCalendar: iwInputCalendar
    },

    props: {
        defaultDate: {
            type: String,
            required: false,
            default: datetime(), // today
        }
    },

    methods: {
        updateExtendedDate: function (value: string) {
            this.$emit("update", value);
        },
    },
});
